import axios from "axios";

// const baseURL = process.env.REACT_APP_API_URL;
// const baseAuthURL = process.env.REACT_APP_AUTH_URL;
const baseURL = window.REACT_APP_API_URL || "https://hoytoca2025-recipe-service.prd.cloudherdez.com";
const baseAuthURL = window.REACT_APP_AUTH_URL || "https://hoytoca2025-user-service.prd.cloudherdez.com";

// const apikey = process.env.REACT_APP_API_KEY;
const apikey = window.API_KEY || "HoyToca-Secret-2025~Di56m1-6BZWu6e+h>C";

// Configuración base para axios
const axiosInstance = axios.create({
  headers: {
    "Content-Type": "application/json",
    'x-api-key': apikey,
  },
});

// Interceptor para manejar el token automáticamente
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
      
    }
    return config;
  },
  (error) => {
    console.error("Error en el interceptor de solicitud:", error);
    return Promise.reject(error);
  }
);

// Función genérica para manejar solicitudes
export const ApiRequest = async (endpoint, method = "GET", data = null) => {
  try {
    const config = {
      method,
      url: `${baseURL}/${endpoint}`,
      data,
    };

    const response = await axiosInstance(config);
    return response.data; // Devuelve la respuesta de la API
  } catch (error) {
    console.error(`Error during ${method} request to ${endpoint}:`, error.response || error);
    throw error.response || error; // Lanza el error para que el componente pueda manejarlo
  }
};

// Función específica para autenticación
export const ApiAuthRequest = async (endpoint, method = "GET", data = null) => {
  try {
    const config = {
      method,
      url: `${baseAuthURL}/${endpoint}`,
      data,
    };

    const response = await axiosInstance(config);
    return response.data; // Devuelve la respuesta de la API
  } catch (error) {
    console.error(`Error during ${method} request to ${endpoint}:`, error.response || error);
    throw error.response || error; // Lanza el error para que el componente pueda manejarlo
  }
};


/*
import axios from "axios";
//import { useAuth } from "../context/AuthContext";

const baseURL = process.env.REACT_APP_API_URL;
const baseAuthURL = process.env.REACT_APP_AUTH_URL;
// Función genérica para manejar solicitudes
export const ApiRequest = async (endpoint, method = "GET", data = null) => {
  const token = localStorage.getItem("token");
  try {
    const config = {
      method,
      url: `${baseURL}/${endpoint}`,
      //url: `/${endpoint}`, // Se usara el proxy del package.json
      data,
      headers: {
        "Content-Type": "application/json",
        // Agrega más encabezados si es necesario
      },
    };

    if (tokenLogin) {
      config.headers['Authorization'] = `Bearer ${tokenLogin}`;
    }

    const response = await axios(config);
    return response.data; // Devuelve la respuesta de la API
  } catch (error) {
    console.error(`Error during ${method} request to ${endpoint}:`, error);
    throw error; // Lanza el error para que el componente pueda manejarlo
  }
};


export const ApiAuthRequest = async (endpoint, method = "GET", data = null) => {
  const token = localStorage.getItem("token");
  try {
    const config = {
      method,
      url: `${baseAuthURL}/${endpoint}`,
      //url: `/${endpoint}`, // Se usara el proxy del package.json
      data,
      headers: {
        "Content-Type": "application/json",
        // Agrega más encabezados si es necesario
      },
    };
    if (tokenLogin) {
      config.headers['Authorization'] = `Bearer ${tokenLogin}`;
    }

    const response = await axios(config);
    return response.data; // Devuelve la respuesta de la API
  } catch (error) {
    console.error(`Error during ${method} request to ${endpoint}:`, error);
    throw error; // Lanza el error para que el componente pueda manejarlo
  }
};
*/